(function($) {

  $(document).ready(function() {

    // Nominate the containing selector
    var parentSelector = $(".quantity");
    // If it's on the page
    if (parentSelector.length) {

      // Get the original HTML
      var numberInputs = parentSelector.html();
      // Change number to text
      var textInputs = numberInputs.replace("type=\"number\"", "type=\"text\"");
      // Plus button
      var btnPlus = "<button class=\"btn btn-number-input btn-plus\">+</button>";
      // Minus button
      var btnMinus = "<button class=\"btn btn-number-input btn-minus\">-</button>";
      // Append it all
      parentSelector.append(textInputs + btnMinus + btnPlus);
      // Hide the original
      parentSelector.find("input[type=\"number\"]").hide();

      // increase or decrease the count
      $(".btn-plus, .btn-minus").on("click", function(e) {

        e.preventDefault();

        var $newCounter = $(this).prevAll("input.qty[type=\"text\"]:first");
        var $oldCounter = $(this).prevAll("input.qty[type=\"number\"]:first");
        var counterVal = $newCounter.val();

        if ($(e.target).hasClass("btn-plus")) {

          counterVal++;

        } else {

          counterVal--;
        }

        // Apply to both inputs
        $newCounter.val(counterVal);
        $oldCounter.val(counterVal);

        $("input[name=\"update_cart\"]").prop("disabled", false);

        // Use .attr() instead of .val()
        // $newCounter.attr("value", counterVal);
        // $oldCounter.attr("value", counterVal);

      });
    }

  });

})(jQuery);